<template>
  <div>
    <b-modal id="modal-reservation" hide-footer>
      <h3>{{ getLanguage.calendarText.headerReserve }}</h3>
      <h4 v-if="calendar.title != ''">{{ calendar.title }}</h4>
      <p>{{ calendar.date | moment(("dddd, DD.MM.YYYY")) }}</p>
      <p v-if="error" class="error">{{ getLanguage.errors.overlap }}</p>
      <p v-if="errorMsg != ''" class="error" v-html="errorMsg">{{ errorMsg }}</p>
      <ValidationObserver v-slot="{ handleSubmit }">
        <b-form v-if="getUserId > 0" @submit.prevent="handleSubmit(onSubmit)">
          <b-form-group :label="`${getLanguage.formTimeFrom}:*`">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <b-form-select v-model="event.from" :options="calendar.from" @change="onChange"></b-form-select>
            </ValidationProvider>
          </b-form-group>
          <b-form-group :label="`${getLanguage.formTimeTo}:*`">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <b-form-select v-model="event.to" :options="calendar.to" @change="onChange"></b-form-select>
            </ValidationProvider>
          </b-form-group>
          <b-form-group :label="`${getLanguage.formTitle}`">
            <b-form-input v-model="event.title" placeholder="z.B. Kunde Paul, Gast Fritz ..." trim></b-form-input>
          </b-form-group>
          <div v-if="isAdmin">
            <h3>Admin</h3>
            <b-form-group :label="`${getLanguage.formState}:`">
              <b-form-select v-model="event.flag" :options="rangeOptions" @change="onChangeRange"></b-form-select>
            </b-form-group>
            <div v-if="event.flag != 'event'">
              <b-form-group :label="`${getLanguage.formDateFrom}`">
                <ValidationProvider rules="" vid="range_from" v-slot="x">
                  <b-form-input v-model="event.range_from" type="date" trim></b-form-input>
                  <span class="note">{{ getLanguage.errors.recurring }}</span>
                </ValidationProvider>
              </b-form-group>
              <b-form-group :label="`${getLanguage.formDateTo}`">
                <ValidationProvider rules="required_if:range_from" v-slot="{ errors }">
                  <b-form-input v-model="event.range_to" type="date" trim></b-form-input>
                  <span class="note">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
              <b-form-group :label="`${getLanguage.formDays}`">
                <ValidationProvider rules="required_if:range_from" v-slot="{ errors }">
                  <b-form-checkbox-group v-model="event.range_day" :options="dayOptions" name="days"></b-form-checkbox-group>
                  <span class="note">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-form-group>
            </div>
          </div>
          <b-button type="submit" variant="primary" :disabled="error">{{ getLanguage.formBtnReserve }}</b-button>
        </b-form>
      </ValidationObserver>
    </b-modal>
    <b-modal id="modal-registerinfo" hide-footer>
      <h3>Sorry</h3>
      <span v-html="getLanguage.notes.registerFirst"></span>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import store from '../store';
import {helpers} from '../shared/mixin';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required_if, required} from 'vee-validate/dist/rules';

let messages = {
  required_if: 'Dieses Feld muss in der ausgewählten Konfiguration ebenfalls eingegeben werden!',
  required: 'Dieses Feld muss eingegeben werden!',
};

let rangeOpt = [
  {value: 'event', text: 'Reservierung (Standard)'},
  {value: 'range', text: 'Abo / Wiederkehrend'},
  {value: 'blocked', text: 'Gesperrt / Geblockt'},
];

let dayOpt = [
  {value: 'Mo', text: 'Mo'},
  {value: 'Di', text: 'Di'},
  {value: 'Mi', text: 'Mi'},
  {value: 'Do', text: 'Do'},
  {value: 'Fr', text: 'Fr'},
  {value: 'Sa', text: 'Sa'},
  {value: 'So', text: 'So'},
];

if (store.getters.getLangCode != 'de') {
  messages = {
    required_if: 'This field is required in the selected configuration!',
    required: 'This field is required!',
  };

  rangeOpt = [
    {value: 'event', text: 'Reservation (default)'},
    {value: 'range', text: 'Abo / Recurring'},
    {value: 'blocked', text: 'Blocked'},
  ];

  dayOpt = [
    {value: 'Mo', text: 'Mo'},
    {value: 'Di', text: 'Tu'},
    {value: 'Mi', text: 'We'},
    {value: 'Do', text: 'Th'},
    {value: 'Fr', text: 'Fr'},
    {value: 'Sa', text: 'Sa'},
    {value: 'So', text: 'Su'},
  ];
}

// validation
extend('required_if', {
  ...required_if,
  message: messages.required_if
});

extend('required', {
  ...required,
  message: messages.required
});

export default {
  name: "Modal",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: ["calendar", "view"],
  mixins: [helpers],
  data() {
    return {
      event: {
        flag: 'event',
        title: '',
        from: '',
        to: '',
        range_from: '',
        range_to: '',
        range_day: [],
      },
      rangeOptions: rangeOpt,
      dayOptions: dayOpt,
      error: false,
      errorMsg: '',
    }
  },
  watch: {
    'event.from': function (val) {
      this.error = false;

      if (val > this.event.to || val == this.event.to) {
        this.error = true;
      }
    },
    'event.to': function (val) {
      this.error = false;

      if (val < this.event.from || val == this.event.from) {
        this.error = true;
      }
    },
    times() {
      this.event.from = this.times.start;
      this.event.to = this.times.end;
    }
  },
  methods: {
    ...mapActions(['addEvent', 'getEvents']),
    async onSubmit() {
      // data required for creating an event from calendar object
      const data = {
        date: this.$moment(this.calendar.date).format('YYYY-MM-DD'),
        resource: this.calendar.resource,
        user_token: this.getUserToken,
      };

      const response = await this.addEvent({...this.event, ...data});

      // validation error - status 422 from laravel validation
      if (response.status == 422) {
        this.errorMsg = this.showErrors(response.data);
      } else {
        this.$bvModal.hide('modal-reservation');

        await this.getEvents({start: this.view.start, end: this.view.end});
      }
    },
    onChangeRange() {
      if (this.event.flag == 'event') {
        // reset range_from when switching from multiple back to event!
        // range_from indicator in laravel for range events
        this.range_from = '';
      }
    },
    onChange() {
      // nur ausführen wenn nicht bereits ein error von watch gesetzt wurde ...
      if (!this.error) {
        this.overlapCheck();
      }
    },
    overlapCheck() {
      const arrFrom = this.calendar.from;
      const arrTo = this.calendar.to;

      const diff = parseInt(this.event.to) - parseInt(this.event.from);
      const diff2 = arrTo.findIndex(v => v == this.event.to) - arrFrom.findIndex(v => v == this.event.from);

      // check if overlapping
      if ((diff - diff2) > 1) {
        this.error = true;
      }
    }
  },
  computed: {
    ...mapState(['times']),
    ...mapGetters(['getUserToken', 'getUserId', 'userIsAdmin', 'getLanguage']),
    isAdmin() {
      return this.userIsAdmin;
    }
  }
}
</script>

<style scoped>

</style>